import React from "react";
import { CustomChips, TextMidCut } from "../../../../../common/components";
import { isSegFeatureEnabled, SegFlags, translate } from "../../../../../common/providers";
import styles from "./DocumentCenterPanelTitle.module.css";

const DocumentCenterPanelTitle = React.forwardRef(({ docType, title }) => (
	<span className={styles.title}>
		<TextMidCut
			showWhenOverflow
			tooltip
			autoTranslate="no"
			className={styles.label__text}
			data-is-deliverable={docType === "DELIVERABLE"}
			text={title}
		/>
		{isSegFeatureEnabled(SegFlags.DOC_TYPE_DELIVERABLE) && docType === "DELIVERABLE" && (
			<CustomChips
				className={styles.label__chip}
				color="info"
				label={translate("document-center.table.actions.type.deliverable")}
				size="sm"
			/>
		)}
	</span>
));
export default DocumentCenterPanelTitle;
